import produce from 'immer';
import {
  authClean,
  changePassword,
  forgotPassword,
  login,
  logout,
  rememberMe,
  showConfirmPassword,
  showNewPassword,
  showPassword,
  verifySession,
} from './actions';

import { CLEAR_STORE } from './types';

/* eslint-disable default-case */
/* eslint-disable no-underscore-dangle */

const initialState = {
  loading: false,
  error: null,
  isLoggedIn: false,
  retry: [],
  resendTime: null,
  showPassword: false,
  showNewPassword: false,
  showConfirmPassword: false,
  ability: null,
  userInitiatedLogout: false,
  // Whether this page load has established with the API whether a session
  // exists. A cold load starts with no auth state even when the browser holds a
  // valid session cookie, so `isLoggedIn: false` only means "signed out" once
  // this is true. Never persisted — it is a fact about this page load.
  sessionChecked: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case login.TRIGGER:
    case forgotPassword.TRIGGER:
    case changePassword.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case logout.TRIGGER:
      draft.loading = true;
      draft.error = null;
      // Recorded before the request runs so the redirect that follows
      // logout.SUCCESS can tell a deliberate log out from an expired session.
      draft.userInitiatedLogout = payload?.userInitiated === true;
      // Logging out settles the question: there is no session to find.
      draft.sessionChecked = true;
      break;
    case verifySession.SUCCESS:
    case login.SUCCESS:
      draft.isLoggedIn = true;
      draft.ability = payload.ability;
      draft.userInitiatedLogout = false;
      draft.sessionChecked = true;
      break;
    case verifySession.FAILURE:
      draft.sessionChecked = true;
      break;
    // The store is wiped when logging out. Keeping this flag set stops the
    // redirect that is already under way from flipping back to a fresh check.
    case CLEAR_STORE:
      draft.sessionChecked = true;
      break;
    case changePassword.SUCCESS:
      draft.userId = payload;
      break;
    case logout.SUCCESS:
      draft.isLoggedIn = false;
      draft.ability = null;
      break;
    case login.FAILURE:
    case logout.FAILURE:
      draft.error = payload;
      break;
    case forgotPassword.FAILURE:
      draft.error = payload;
      break;
    case changePassword.FAILURE:
      draft.error = payload;
      break;
    case login.FULFILL:
    case logout.FULFILL:
    case forgotPassword.FULFILL:
    case changePassword.FULFILL:
      draft.loading = false;
      break;

    case showPassword.toString():
      draft.showPassword = payload;
      break;
    case showNewPassword.toString():
      draft.showNewPassword = payload;
      break;
    case showConfirmPassword.toString():
      draft.showConfirmPassword = payload;
      break;

    case rememberMe.toString():
      draft.rememberMe = payload;
      break;
    case authClean.toString():
      draft.emailRecover = null;
      draft.userId = null;
      break;
    // no default
  }
}, initialState);

export default reducer;
